import { Model } from 'pinia-orm';
import Job from './Job';
import Competence from './Competence';

export default class JobCompetence extends Model {

    static get entity () {
        return 'job_competences';
    }

    static fields () {
        return {
            id: this.uid(),
            job_id: this.attr(null),
            weight: this.string('default'),
            order: this.number(0),
            competence_id: this.attr(null),
            created_at: this.attr(null),
            job: this.belongsTo(Job, 'job_id'),
            competence: this.belongsTo(Competence, 'competence_id'),
        }
    }
}
